var _a;
import Value from "./Value";
import Variation from "./Variation";
import Range from "./Range";
class YieldGuidance {
    range;
    value;
    variation;
    constructor(response) {
        this.range = response.range !== undefined ? new Range(response.range) : undefined;
        this.value = response.value !== undefined ? new Value(response.value) : undefined;
        this.variation = response.variation !== undefined ? new Variation(response.variation) : undefined;
    }
    print() {
        const items = [];
        if (this.value !== undefined) {
            items.push(...this.value.printYield());
        }
        else if (this.range) {
            items.push(...this.range.printYield());
        }
        if (this.variation !== undefined) {
            items.push(...this.variation.printYield());
        }
        return items.join(" ");
    }
    #clone() {
        return new _a(this);
    }
    updateRange(newRange) {
        const clone = this.#clone();
        clone.range = newRange;
        delete clone.value;
        return clone;
    }
    updateValue(newValue) {
        const clone = this.#clone();
        clone.value = newValue;
        delete clone.range;
        return clone;
    }
    updateVariation(newVariation) {
        const clone = this.#clone();
        clone.variation = newVariation;
        return clone;
    }
}
_a = YieldGuidance;
export default YieldGuidance;
